import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Editor } from "@tinymce/tinymce-react";
import { getBaseURL } from '../../../Api/ApiConfig'
import ETemplateQP from '../Popup/ETemplateQP'
// import SignaturePad from "signature_pad";

function TinyMCEEditor({ placeholder, setContent, content, edit, page, setFiles, height, selectedEntity }) {
    const clickTrackUrl = process.env.REACT_APP_CLICK_URL
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editorPointer, setEditorPointer] = useState(null);
    // let signaturePad = null;
    let toolbars = "";
    let location = "";
    if (page === "Email") {
        location = "bottom";
        toolbars = `undo redo | customAttachment customImage customLink |styles | backcolor forecolor | numlist bullist | indent outdent alignnone | lineheight fontfamily fontsize | hr openlink unlink | remove removeformat | cut copy paste selectall searchreplace table emoticons code fullscreen`;
    } else if (page === "Outreach") {
        location = "bottom";
        toolbars = `undo redo | customImage customLink | styles | backcolor forecolor | numlist bullist | indent outdent alignnone | lineheight fontfamily fontsize | hr openlink unlink | remove removeformat | cut copy paste selectall searchreplace table emoticons code fullscreen`;
    } else if (page === "Template") {
        location = "top";
        toolbars = `undo redo | customInsertVariable customImage customLink | styles | backcolor forecolor | numlist bullist | indent outdent alignnone | lineheight fontfamily fontsize | hr openlink unlink | remove removeformat | cut copy paste selectall searchreplace table emoticons code fullscreen`;
    } else if (page === "Signature") {
        location = "bottom";
        toolbars = `undo redo | customImage customLink table | styles | backcolor forecolor | numlist bullist | indent outdent alignnone | lineheight fontfamily fontsize | hr openlink unlink | remove removeformat | cut copy paste selectall searchreplace emoticons code fullscreen`;
    } else if (page === "TextBox") {
        location = "bottom";
        toolbars = `undo redo | copy customLink table | styles | backcolor forecolor | numlist bullist | indent outdent alignnone | lineheight fontfamily fontsize | hr openlink unlink | remove removeformat | cut copy paste selectall searchreplace emoticons code fullscreen`;
    }
    const handleImageUpload = async (file, editor) => {
        const formData = new FormData();
        formData.append("file", file);
        try {
            const response = await axios.post(
                `${getBaseURL()}/usermgmt/uploadFile`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            editor.insertContent(
                `<img src="${response.data.mediaUrl}" alt="${response.data.mediaName}" />`
            );
        } catch (error) {
            message.error(error.response.data.message.message)
        }
    };
    const handlefileuploadChange = async (event) => {
        const files = Array.from(event.target.files);
        const filesBufferData = await Promise.all(
            files.map(async (file) => {
                const arrayBuffer = await file.arrayBuffer();
                return {
                    filename: file.name,
                    contentType: file.type,
                    size: file.size,
                    contentDisposition: "attachment",
                    content: {
                        type: "Buffer",
                        data: Array.from(new Uint8Array(arrayBuffer)),
                    },
                };
            })
        );
        setFiles((prevFiles) => [...prevFiles, ...filesBufferData]);
    };
    const uploadPastedOrDroppedImage = async (file, imgElement) => {
        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await axios.post(
                `${getBaseURL()}/usermgmt/uploadFile`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            const url = response.data.mediaUrl;
            imgElement.src = url; // ✅ replace blob/empty placeholder with real URL
        } catch (err) {
            message.error(err.response.data.message.message);
            imgElement.remove(); // clean up broken placeholder
        }
    };
    const handleSaveContent = (data) => {
        editorPointer.insertContent(`${data}`);
        setIsModalOpen(false);
    };
    useEffect(() => {
        if (!editorPointer) return;
        const handleOutsideClick = (e) => {
            try {
                const overflowToolbar = document.querySelector('.tox-toolbar__overflow');
                if (overflowToolbar && overflowToolbar.style.display !== 'none') {
                    if (overflowToolbar.contains(e.target)) return;
                    const popupEl = document.querySelector('.tox-menu, .tox-pop');
                    if (popupEl && popupEl.contains(e.target)) return;
                    editorPointer.execCommand('ToggleToolbarDrawer', false, { skip_focus: true });
                }
            } catch (err) {
                // ignore errors silently
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        const iframeDoc = editorPointer.iframeElement?.contentDocument;
        if (iframeDoc) {
            iframeDoc.addEventListener('mousedown', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            if (iframeDoc) {
                iframeDoc.removeEventListener('mousedown', handleOutsideClick);
            }
        };
    }, [editorPointer]);

    return (
        <>
            <Editor
                disabled={!edit || !selectedEntity}
                onInit={(evt, editorInstance) => setEditorPointer(editorInstance)}
                // apiKey="g66dky2ypv8zumscjn4407wennsia8n8cjf4pjwnann83n8e" // Use your API key here
                value={content || '<div></div>'}
                init={{
                    plugins: [
                        "fullscreen",
                        "link",
                        "lists",
                        "code",
                        "table",
                        "searchreplace",
                        "advlist",
                        "emoticons",
                        "image",
                    ],
                    placeholder,
                    toolbar: toolbars,
                    toolbar_location: location,
                    height,
                    statusbar: false,
                    branding: false,
                    menubar: false,
                    forced_root_block: 'div',

                    convert_urls: true,       // ensure conversion
                    relative_urls: false,     // force absolute URLs
                    remove_script_host: false,// keep protocol+host

                    paste_preprocess: (_, args) => {
                        if (!args.content) return;
                        args.content = args.content
                            .replace(/<\s*p(\b[^>]*)>/gi, '<div$1>')
                            .replace(/<\/\s*p\s*>/gi, '</div>');
                    },
                    mobile: {
                        theme: "silver",
                        width: "100%",
                        height: 300,
                    },
                    setup: (editor) => {
                        // if (page === "TextBox") {
                        //     editor.on('click', (e) => {
                        //         const { target } = e;
                        //         if (target.classList.contains('placeholder')) {
                        //             const sel = editor.selection; // save current selection
                        //             target.remove(); // remove only the clicked placeholder
                        //             setContent(editor.getContent()); // update your React state
                        //             sel.collapse(); // maintain cursor position
                        //         }
                        //     });
                        // }
                        editor.on('keydown', (e) => {
                            if (e.key !== 'Backspace' && e.key !== 'Delete') return;

                            const sel = editor.selection;
                            const rng = sel.getRng();
                            const node = sel.getNode();

                            // Get both protected blocks
                            const protectedBlocks = [
                                editor.dom.get('ReplyContent'),
                                editor.dom.get('ForwardContent')
                            ].filter(Boolean); // ignore if not present

                            protectedBlocks.some(block => {
                                const atStart = rng.startOffset === 0;
                                const atEnd = rng.startOffset === node.textContent?.length;

                                if ((e.key === 'Backspace' && atStart && node.nextSibling === block) ||
                                    (e.key === 'Delete' && atEnd && node.previousSibling === block)) {
                                    e.preventDefault();
                                    return true; // stops .some iteration
                                }
                                return false;
                            });
                        });


                        // editor.ui.registry.addButton("customLink", {
                        //     icon: "link",
                        //     tooltip: "Insert/edit link",
                        //     onAction: () => {
                        //         const selectedText = editor.selection.getContent({ format: "text" });
                        //         editor.windowManager.open({
                        //             title: "Insert/Edit Link",
                        //             body: {
                        //                 type: "panel",
                        //                 items: [
                        //                     { type: "input", name: "url", label: "URL" },
                        //                     { type: "input", name: "text", label: "Text to display", value: selectedText },
                        //                     { type: "input", name: "title", label: "Title" },
                        //                     { type: "checkbox", name: "track", label: "Add Tracking URL", checked: true },
                        //                 ],
                        //             },
                        //             buttons: [
                        //                 { type: "cancel", text: "Cancel" },
                        //                 { type: "submit", text: "Insert", primary: true },
                        //             ],
                        //             onSubmit: (api) => {
                        //                 const data = api.getData();
                        //                 let finalUrl = data.url.trim();

                        //                 // Normalize URL
                        //                 if (finalUrl.startsWith("www.")) {
                        //                     finalUrl = `https://${finalUrl}`;
                        //                 }
                        //                 if (
                        //                     /^[a-z0-9.-]+\.[a-z]{2,}$/i.test(finalUrl) &&
                        //                     !finalUrl.startsWith("http")
                        //                 ) {
                        //                     finalUrl = `https://${finalUrl}`;
                        //                 }

                        //                 // Apply click tracking if checked
                        //                 if (data.track) {
                        //                     finalUrl = clickTrackUrl + finalUrl;
                        //                 }

                        //                 // ✅ Only add title if user entered something
                        //                 const titleAttr = data.title ? ` title="${data.title}"` : "";

                        //                 // Build final <a> tag
                        //                 const linkHTML = `<a href="${finalUrl}"${titleAttr} target="_blank" rel="noopener noreferrer">${data.text || finalUrl}</a>`;

                        //                 editor.insertContent(linkHTML);
                        //                 api.close();
                        //             }

                        //         });
                        //     },
                        // });
                        editor.ui.registry.addButton("customLink", {
                            icon: "link",
                            tooltip: "Insert/edit link",
                            onAction: () => {
                                const { dom, selection } = editor;
                                const node = selection.getNode();

                                // 🧠 Find nearest <a> tag even if selection is inside text/div/span
                                const anchorNode = node?.nodeName === "A" ? node : dom.getParent(node, "a");

                                // Default values
                                let initialUrl = "";
                                let initialText = selection.getContent({ format: "text" }) || "";
                                let initialTitle = "";
                                let initialTrack = false;

                                // ✅ If editing an existing link
                                if (anchorNode) {
                                    const href = dom.getAttrib(anchorNode, "href");
                                    const title = dom.getAttrib(anchorNode, "title");
                                    const linkText = anchorNode.textContent?.trim() || "";

                                    if (href?.startsWith(clickTrackUrl)) {
                                        initialUrl = href.replace(clickTrackUrl, "");
                                        initialTrack = true;
                                    } else {
                                        initialUrl = href || "";
                                        initialTrack = false;
                                    }

                                    if (linkText) initialText = linkText;
                                    initialTitle = title || "";
                                }
                                // 🪟 Open custom dialog
                                editor.windowManager.open({
                                    title: anchorNode ? "Edit Link" : "Insert Link",
                                    body: {
                                        type: "panel",
                                        items: [
                                            { type: "input", name: "url", label: "URL" },
                                            { type: "input", name: "text", label: "Text to display" },
                                            { type: "input", name: "title", label: "Title" },
                                            { type: "checkbox", name: "track", label: "Add Tracking URL", classes: "small-label-checkbox" },
                                        ],
                                    },
                                    initialData: {
                                        url: initialUrl,
                                        text: initialText,
                                        title: initialTitle,
                                        track: initialTrack,
                                    },
                                    buttons: [
                                        { type: "cancel", text: "Cancel" },
                                        { type: "submit", text: anchorNode ? "Update" : "Insert", primary: true },
                                    ],

                                    onSubmit: (api) => {
                                        const data = api.getData();
                                        let finalUrl = data.url.trim();

                                        // Normalize URL
                                        if (finalUrl.startsWith("www.")) finalUrl = `https://${finalUrl}`;
                                        if (/^[a-z0-9.-]+\.[a-z]{2,}$/i.test(finalUrl) && !finalUrl.startsWith("http")) {
                                            finalUrl = `https://${finalUrl}`;
                                        }

                                        // Apply click tracking if checked
                                        if (data.track) finalUrl = clickTrackUrl + finalUrl;

                                        const linkText = data.text || finalUrl;
                                        const titleAttr = data.title?.trim() || "";

                                        if (anchorNode) {
                                            // 🛠 Update existing <a>
                                            dom.setAttrib(anchorNode, "href", finalUrl);
                                            dom.setAttrib(anchorNode, "target", "_blank");
                                            dom.setAttrib(anchorNode, "rel", "noopener noreferrer");
                                            dom.setAttrib(anchorNode, "title", titleAttr || null);
                                            dom.setHTML(anchorNode, dom.encode(linkText));
                                        } else {
                                            // 🆕 Insert new <a>
                                            const titlePart = titleAttr ? ` title="${titleAttr}"` : "";
                                            const html = `<a href="${finalUrl}"${titlePart} target="_blank" rel="noopener noreferrer">${linkText}</a>`;
                                            editor.insertContent(html);
                                        }

                                        api.close();
                                    },
                                });
                            },
                        });
                        // Replace the default link button with your version
                        editor.ui.registry.addButton("link", {
                            icon: "link",
                            tooltip: "Insert/edit link",
                            onAction: () => editor.execCommand("customLink"),
                        });
                        // Custom Image Button
                        editor.ui.registry.addIcon(
                            'attachmentIcon',
                            `<svg viewBox="0 0 24 24" height="24" width="20" focusable="false"
        stroke="currentColor" stroke-width="2"
        fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path fill="none" 
        d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
  </svg>`
                        );
                        editor.ui.registry.addIcon(
                            'insertVariable',
                            `<svg viewBox="0 0 512 512" height="24" width="24" focusable="false"
        stroke="currentColor" stroke-width="2"
        fill="none" stroke-linecap="round" stroke-linejoin="round">
        <g>
<path d="M0 0 C14.88686393 7.91432611 26.246465 19.79053686 31.875 35.875 C32.12664413 36.54090149 32.37828827 37.20680298 32.63755798 37.8928833 C35.46190775 46.46845477 35.11584181 54.75625654 34.8883419 63.66103172 C34.77729374 68.43548192 34.75409117 73.21085866 34.71289062 77.98632812 C34.65368681 84.0264051 34.57009368 90.06359989 34.40551758 96.10180664 C32.40775718 120.69195933 32.40775718 120.69195933 41.49531555 142.24153137 C44.2034252 144.60990121 47.02493598 146.60065866 50.06900024 148.51089478 C53.53335012 151.1275827 55.0796922 154.82045486 56.625 158.8125 C57.41163864 165.3022688 57.33398679 171.14944067 53.875 176.875 C51.31781973 179.98935451 48.64992422 182.9430172 45.859375 185.84765625 C45.41330902 186.32572723 44.96724304 186.80379822 44.50765991 187.2963562 C42.875 188.875 42.875 188.875 41.0790863 190.02609253 C37.23988294 192.81060602 36.00755937 195.0494261 35.24960327 199.76994324 C34.93996873 204.8779332 35.03776049 209.98378882 35.11328125 215.09765625 C35.11405459 217.00467622 35.11116064 218.91170086 35.1047821 220.81871033 C35.09520062 225.83604686 35.12377758 230.85234754 35.16394043 235.86950684 C35.22539926 243.87284785 35.24506161 251.87590577 35.23412132 259.87945366 C35.23818186 262.65472471 35.26835842 265.42881299 35.30110168 268.20387268 C35.40908671 288.06943456 29.90514173 304.28278788 15.875 318.875 C2.20819133 331.18482058 -13.46255896 336.4804426 -31.625 336.1875 C-38.00522296 335.61783724 -41.43031499 333.53202535 -45.9375 329.125 C-49.93421199 323.1870279 -52.33285872 317.16332935 -51.125 309.875 C-48.96731972 302.33596236 -44.93966597 297.88958815 -38.390625 293.7890625 C-35.79383783 292.74139319 -33.2526615 292.3713721 -30.48901367 291.98950195 C-23.73662717 291.02487531 -18.71432994 289.88693274 -13.60546875 285.08203125 C-9.40890747 278.82594385 -8.69058138 272.80750361 -8.77197266 265.49658203 C-8.76981247 264.59464111 -8.76765228 263.6927002 -8.76542664 262.76342773 C-8.76235441 260.81774986 -8.76590164 258.87205234 -8.77544022 256.92639542 C-8.78925616 253.83954262 -8.78269498 250.75332714 -8.77059937 247.66647339 C-8.73974714 238.89463 -8.74448509 230.12293805 -8.76464844 221.35107422 C-8.77560232 215.97299149 -8.76229997 210.59538903 -8.73475266 205.21737289 C-8.72933499 203.17698334 -8.73331708 201.13654507 -8.74715042 199.09619522 C-8.89718767 176.70805895 -8.89718767 176.70805895 -0.3125 167.75 C0.409375 167.13125 1.13125 166.5125 1.875 165.875 C0.14697488 162.14479194 -2.14028176 159.17578319 -4.6875 155.97265625 C-8.30219021 150.69795885 -8.41486534 145.9951274 -8.39624023 139.80541992 C-8.40146698 138.9007045 -8.40669373 137.99598907 -8.41207886 137.06385803 C-8.42230305 135.10340798 -8.4280965 133.14293089 -8.42996025 131.18245506 C-8.43362917 128.07547265 -8.45037113 124.96880793 -8.47071838 121.8618927 C-8.52607538 113.02965207 -8.55678551 104.19736461 -8.58129883 95.36499023 C-8.59720842 89.95802408 -8.62746426 84.55128318 -8.66606331 79.14443398 C-8.67768432 77.08845734 -8.6836434 75.03244037 -8.68374443 72.97643089 C-8.68393733 70.09497054 -8.70226651 67.21412769 -8.72436523 64.33276367 C-8.71978806 63.49041168 -8.71521088 62.64805969 -8.710495 61.78018188 C-8.78786668 55.40699235 -9.98557056 50.06438689 -13.60546875 44.66796875 C-18.61735695 39.95427069 -23.64881271 38.92348139 -30.25390625 37.9296875 C-37.50379301 36.79859614 -42.09986153 34.30097535 -47 28.9375 C-50.7157522 23.58244536 -52.03068411 18.3638254 -51.125 11.875 C-49.30196417 4.82301708 -46.40601901 -0.25975753 -40.125 -4.125 C-28.05510491 -10.1289991 -11.41890925 -5.35533176 0 0 Z " transform="translate(413.125,91.125)"/>
<path d="M0 0 C5.36830526 5.24900959 7.62179989 10.59619901 8.4375 17.9375 C8.17227988 23.56237669 6.13250716 28.67947597 2.31640625 32.83203125 C-2.44391765 37.03954334 -6.26758075 39.00553645 -12.63598633 39.88549805 C-19.38837283 40.85012469 -24.41067006 41.98806726 -29.51953125 46.79296875 C-33.71609253 53.04905615 -34.43441862 59.06749639 -34.35302734 66.37841797 C-34.35518753 67.28035889 -34.35734772 68.1822998 -34.35957336 69.11157227 C-34.36264559 71.05725014 -34.35909836 73.00294766 -34.34955978 74.94860458 C-34.33574384 78.03545738 -34.34230502 81.12167286 -34.35440063 84.20852661 C-34.38525286 92.98037 -34.38051491 101.75206195 -34.36035156 110.52392578 C-34.34939768 115.90200851 -34.36270003 121.27961097 -34.39024734 126.65762711 C-34.39566501 128.69801666 -34.39168292 130.73845493 -34.37784958 132.77880478 C-34.22781233 155.16694105 -34.22781233 155.16694105 -42.8125 164.125 C-43.534375 164.74375 -44.25625 165.3625 -45 166 C-43.27197488 169.73020806 -40.98471824 172.69921681 -38.4375 175.90234375 C-34.82280979 181.17704115 -34.71013466 185.8798726 -34.72875977 192.06958008 C-34.72353302 192.9742955 -34.71830627 193.87901093 -34.71292114 194.81114197 C-34.70269695 196.77159202 -34.6969035 198.73206911 -34.69503975 200.69254494 C-34.69137083 203.79952735 -34.67462887 206.90619207 -34.65428162 210.0131073 C-34.59892462 218.84534793 -34.56821449 227.67763539 -34.54370117 236.51000977 C-34.52779158 241.91697592 -34.49753574 247.32371682 -34.45893669 252.73056602 C-34.44731568 254.78654266 -34.4413566 256.84255963 -34.44125557 258.89856911 C-34.44106267 261.78002946 -34.42273349 264.66087231 -34.40063477 267.54223633 C-34.40521194 268.38458832 -34.40978912 269.22694031 -34.414505 270.09481812 C-34.33713332 276.46800765 -33.13942944 281.81061311 -29.51953125 287.20703125 C-24.50764305 291.92072931 -19.47618729 292.95151861 -12.87109375 293.9453125 C-5.62120699 295.07640386 -1.02513847 297.57402465 3.875 302.9375 C7.5907522 308.29255464 8.90568411 313.5111746 8 320 C6.17696417 327.05198292 3.28101901 332.13475753 -3 336 C-11.70924706 340.33229213 -23.66948828 338.49209818 -32.74609375 336.09765625 C-49.72305314 330.37073477 -62.86851081 319.89016671 -71.5625 304.17578125 C-72.86401044 301.46042763 -74.00473952 298.84412028 -75 296 C-75.25164413 295.33409851 -75.50328827 294.66819702 -75.76255798 293.9821167 C-78.58690775 285.40654523 -78.24084181 277.11874346 -78.0133419 268.21396828 C-77.90229374 263.43951808 -77.87909117 258.66414134 -77.83789062 253.88867188 C-77.77868681 247.8485949 -77.69509368 241.81140011 -77.53051758 235.77319336 C-75.53275718 211.18304067 -75.53275718 211.18304067 -84.62031555 189.63346863 C-87.3284252 187.26509879 -90.14993598 185.27434134 -93.19400024 183.36410522 C-96.65835012 180.7474173 -98.2046922 177.05454514 -99.75 173.0625 C-100.69290836 165.28350604 -100.04712209 158.89249343 -95.11328125 152.58984375 C-89.04793321 145.74118723 -89.04793321 145.74118723 -85.79710388 143.44192505 C-81.66660387 140.17965298 -78.9253595 137.22557068 -78.19488525 131.92533875 C-77.81162648 126.81188278 -77.93716036 121.70411177 -78.04296875 116.58203125 C-78.04748131 114.67787705 -78.04742696 112.77370712 -78.04304504 110.86955261 C-78.04108707 105.8683245 -78.08919643 100.86895734 -78.15161133 95.86816406 C-78.24537499 87.88485834 -78.27338106 79.90146162 -78.28124428 71.9176693 C-78.29268308 69.15112144 -78.33196232 66.38604283 -78.37480164 63.61982727 C-78.55743437 43.7683583 -73.01423073 27.5756637 -59 13 C-45.86303598 1.16741539 -16.68140408 -13.32856604 0 0 Z " transform="translate(142,89)"/>
<path d="M0 0 C4.28630858 4.28630858 7.03964171 9.35374069 7.37025452 15.47735596 C7.36803391 16.28565857 7.36581329 17.09396118 7.36352539 17.92675781 C7.36341209 19.30773651 7.36341209 19.30773651 7.36329651 20.71661377 C7.35813522 21.70216248 7.35297394 22.68771118 7.34765625 23.703125 C7.3462413 24.71848328 7.34482635 25.73384155 7.34336853 26.77996826 C7.33777516 30.02000892 7.32522385 33.25998025 7.3125 36.5 C7.30748414 38.69791567 7.30292139 40.89583242 7.29882812 43.09375 C7.2878079 48.47919029 7.27107633 53.86459019 7.25 59.25 C8.08778992 59.24000725 8.08778992 59.24000725 8.94250488 59.22981262 C14.78290012 59.1631748 20.62318643 59.11808192 26.46386719 59.08520508 C28.64034415 59.07016701 30.81679105 59.04973127 32.99316406 59.02368164 C36.13093508 58.9870791 39.2683036 58.97022339 42.40625 58.95703125 C43.37115356 58.94154739 44.33605713 58.92606354 45.3302002 58.91011047 C52.50255793 58.90834462 57.85036762 60.08659757 64 64 C68.90708223 68.90708223 71.04375389 74.15630831 71.5 81 C71.40116071 86.89741081 69.73006929 91.48991761 65.9375 96 C60.21320875 100.79242988 56.03025392 103.38401169 48.57324219 103.36352539 C47.65258972 103.36344986 46.73193726 103.36337433 45.78338623 103.36329651 C44.79783752 103.35813522 43.81228882 103.35297394 42.796875 103.34765625 C41.78151672 103.3462413 40.76615845 103.34482635 39.72003174 103.34336853 C36.47999108 103.33777516 33.24001975 103.32522385 30 103.3125 C27.80208433 103.30748414 25.60416758 103.30292139 23.40625 103.29882812 C18.02080971 103.2878079 12.63540981 103.27107633 7.25 103.25 C7.25999275 104.08778992 7.25999275 104.08778992 7.27018738 104.94250488 C7.3368252 110.78290012 7.38191808 116.62318643 7.41479492 122.46386719 C7.42983299 124.64034415 7.45026873 126.81679105 7.47631836 128.99316406 C7.5129209 132.13093508 7.52977661 135.2683036 7.54296875 138.40625 C7.55845261 139.37115356 7.57393646 140.33605713 7.58988953 141.3302002 C7.59166279 148.53263908 6.72572169 154.30589854 1.9375 160 C-4.26427746 165.19218578 -8.47955831 167.58969001 -16.59765625 167.46875 C-22.45103207 166.87385155 -27.59930808 164.40069192 -31.75 160.25 C-35.26693803 155.16469771 -36.88039043 150.71211691 -36.86352539 144.57324219 C-36.86344986 143.65258972 -36.86337433 142.73193726 -36.86329651 141.78338623 C-36.85813522 140.79783752 -36.85297394 139.81228882 -36.84765625 138.796875 C-36.8462413 137.78151672 -36.84482635 136.76615845 -36.84336853 135.72003174 C-36.83777516 132.47999108 -36.82522385 129.24001975 -36.8125 126 C-36.80748414 123.80208433 -36.80292139 121.60416758 -36.79882812 119.40625 C-36.7878079 114.02080971 -36.77107633 108.63540981 -36.75 103.25 C-37.58778992 103.25999275 -37.58778992 103.25999275 -38.44250488 103.27018738 C-44.28290012 103.3368252 -50.12318643 103.38191808 -55.96386719 103.41479492 C-58.14034415 103.42983299 -60.31679105 103.45026873 -62.49316406 103.47631836 C-65.63093508 103.5129209 -68.7683036 103.52977661 -71.90625 103.54296875 C-72.87115356 103.55845261 -73.83605713 103.57393646 -74.8302002 103.58988953 C-82.00255793 103.59165538 -87.35036762 102.41340243 -93.5 98.5 C-98.40708223 93.59291777 -100.54375389 88.34369169 -101 81.5 C-100.90084549 74.84425365 -98.46844869 68.96844869 -93.75 64.25 C-88.66469771 60.73306197 -84.21211691 59.11960957 -78.07324219 59.13647461 C-77.15258972 59.13655014 -76.23193726 59.13662567 -75.28338623 59.13670349 C-74.29783752 59.14186478 -73.31228882 59.14702606 -72.296875 59.15234375 C-71.28151672 59.1537587 -70.26615845 59.15517365 -69.22003174 59.15663147 C-65.97999108 59.16222484 -62.74001975 59.17477615 -59.5 59.1875 C-57.30208433 59.19251586 -55.10416758 59.19707861 -52.90625 59.20117188 C-47.52080971 59.2121921 -42.13540981 59.22892367 -36.75 59.25 C-36.75666183 58.69147339 -36.76332367 58.13294678 -36.77018738 57.55749512 C-36.8368252 51.71709988 -36.88191808 45.87681357 -36.91479492 40.03613281 C-36.92983299 37.85965585 -36.95026873 35.68320895 -36.97631836 33.50683594 C-37.0129209 30.36906492 -37.02977661 27.2316964 -37.04296875 24.09375 C-37.05845261 23.12884644 -37.07393646 22.16394287 -37.08988953 21.1697998 C-37.09165538 13.99744207 -35.91340243 8.64963238 -32 2.5 C-22.71508186 -6.78491814 -10.66582244 -6.78734155 0 0 Z " transform="translate(270.75,174.75)"/>
</g></svg>`
                        );
                        editor.ui.registry.addButton("customImage", {
                            icon: "image",
                            tooltip: "Insert Image",
                            onAction: () => {
                                const input = document.createElement("input");
                                input.type = "file";
                                input.accept = "image/*";
                                input.onchange = (e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        handleImageUpload(file, editor)
                                    }
                                };
                                input.click();
                            },
                        });
                        // Custom Attachment Button
                        editor.ui.registry.addButton("customAttachment", {
                            icon: "attachmentIcon",
                            tooltip: "Insert Attachment",
                            onAction: () => {
                                const input = document.createElement("input");
                                input.type = "file";
                                input.accept = "*";
                                input.multiple = true;
                                input.onchange = async (event) => {
                                    handlefileuploadChange(event)
                                };
                                input.click();
                            },
                        });
                        // Custom Insert Variable Button
                        editor.ui.registry.addButton("customInsertVariable", {
                            icon: "insertVariable",
                            tooltip: "Insert Variable",
                            onAction: () => {
                                // closeMoreMenu(editor);
                                setIsModalOpen(true)
                            },
                        });
                        editor.on("Paste PostProcess", () => {
                            const imgs = editor.getBody().querySelectorAll("img[src^='blob:']");
                            imgs.forEach(async (img) => {
                                if (img.dataset.uploaded) return;
                                img.dataset.uploaded = "true";
                                const blob = await fetch(img.src).then((r) => r.blob());
                                const ext = blob.type.split("/")[1] || "png";
                                const fileName = blob.name || `pasted-${Date.now()}.${ext}`;
                                const file = new File([blob], fileName, { type: blob.type });
                                uploadPastedOrDroppedImage(file, img);
                            });
                        });
                        editor.on("Drop", (event) => {
                            const { files } = event.dataTransfer;
                            if (files.length > 0) {
                                event.preventDefault();
                                Array.from(files).forEach((file) => {
                                    const tempId = `upload-${Date.now()}`;
                                    editor.insertContent(`<img id="${tempId}" src="" />`);
                                    const imgElement = editor.getBody().querySelector(`#${tempId}`);
                                    if (imgElement) {
                                        uploadPastedOrDroppedImage(file, imgElement);
                                    }
                                });
                            }
                        });
                    },
                }}
                onEditorChange={(content) => {
                    setContent(content);
                }} />
            {isModalOpen && (
                <ETemplateQP showPopup={isModalOpen} setShowPopup={setIsModalOpen} callBack={handleSaveContent} selectedEntity={selectedEntity} />
            )}
        </>
    );
};
TinyMCEEditor.propTypes = {
    setContent: PropTypes.func.isRequired,
    setFiles: PropTypes.func.isRequired,
    content: PropTypes.string.isRequired,
    edit: PropTypes.bool.isRequired,
    placeholder: PropTypes.string,
    page: PropTypes.string.isRequired,
    selectedEntity: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
};
export default TinyMCEEditor;
